module.exports = __webpack_public_path__ + "img/SignOut.ba08801b.svg";